<template>

<core-modal v-on:close="onClose" icon="caret-left">

	<template v-slot:head>

		Edit Tag

	</template>

	<template v-slot:default>

		<core-form-input-textbox :autofocus="true" maxlength="16" name="text" v-on:validate="validate" placeholder="Enter tag" v-model="inputs.text" notes="Maximum of 16 characters." :error="is.error" :disabled="is.loading" :validation="validation.text" />

		<core-form-input-colourpicker title="Background" name="colour" v-on:validate="validate" v-model="inputs.colour" :error="is.error" :disabled="is.loading" :validation="validation.colour" v-if="needStyle" />

		<core-form-input-colourpicker title="Text" name="fore" v-on:validate="validate" v-model="inputs.fore" :error="is.error" :disabled="is.loading" :validation="validation.fore" :is-text="true" v-if="needStyle" />

		<core-form-input-togglelist title="Seen by" name="public" v-on:validate="validate" v-model="inputs.public" :error="is.error" :disabled="is.loading" :validation="validation.public" :options="publicOptions" v-if="!isFamily" />

		<core-form-input-togglelist title="Attaches to" name="context" v-on:validate="validate" v-model="inputs.context" :error="is.error" :disabled="is.loading" :validation="validation.context" :options="contextOptions" :notes="contextChanged ? 'Existing attachments will be re-applied to your matching items in the new context. Attachments may be added or removed depending on what you have.' : false" v-if="!isFamily" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading" :disabled="!is.valid">Save</core-button>

		<core-button theme="blue" v-on:click.native="onMoveClick" :loading="is.loading" :disabled="!is.valid" v-if="canMove">Move</core-button>

		<core-button theme="red" v-on:click.native="onDeleteClick">Delete</core-button>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'

export default {

	props: ['data'],
	
	mixins: [FormValidation],

	data: function() {

		return {

			is: {
				loading: false
			},

			inputs: {
				text: '',
				family: 0,
				public: 1,
				context: 0,
				colour: '#134677',
				fore: '#ffffff'
			},

			validation: {
				text: {
					exists: true,
					max: 16
				}
			}

		}

	},

	created: function() {

		this.inputs.family = this.tag.family
		this.inputs.text = this.tag.text
		this.inputs.public = this.tag.public
		this.inputs.context = this.tag.context
		this.inputs.colour = this.tag.colour
		this.inputs.fore = this.tag.fore

	},

	computed: {

        family: function() {

            return (this.isFamily) ? this.$_.find(this.$store.getters['data/tagFamilies/list'], function(family) {

                return family.id === this.inputs.family

            }.bind(this)) : false

        },

		canMove: function() {

			return this.families.length

		},

		families: function() {

			return this.$store.getters['data/tagFamilies/list']

		},

		isFamily: function() {

			return this.inputs.family

		},

		needStyle: function() {

			return !this.isFamily || !this.family.style

		},

		tag: function() {

			return this.$store.getters['data/tags'][this.data.tag]

		},

		publicOptions: function() {

			return [{
				value: 1,
				title: 'Everyone',
				text: 'Anyone viewing your profile can see this tag and filter with it.'
			}, {
				value: 0,
				title: 'Only me',
				text: 'Only you can see this tag and filter with it.'
			}]

		},

		contextOptions: function() {

			return [{
				value: this.$CONSTANTS.TAG.CONTEXT.GAME,
				title: 'Game',
				text: 'The tag is associated with the game and will be shown whenever the game appears in your profile.'
			}, {
				value: this.$CONSTANTS.TAG.CONTEXT.COLLECTION,
				title: 'Collection',
				text: 'The tag is associated with specific collection entries and will not appear elsewhere.'
			}, {
				value: this.$CONSTANTS.TAG.CONTEXT.RATING,
				title: 'Rating',
				text: 'The tag is associated with specific rating entries and will not appear elsewhere.'
			}, {
				value: this.$CONSTANTS.TAG.CONTEXT.PLAY,
				title: 'Play',
				text: 'The tag is associated with specific play entries and will not appear elsewhere.'
			}]

		},

		contextChanged: function() {

			return this.tag && parseInt(this.inputs.context) !== parseInt(this.tag.context)

		}

	},

	methods: {

		onConfirmClick: function() {

			if (this.is.valid) {

				this.is.loading = true

				this.$store.dispatch('api/tags/update', {
					tag: this.data.tag,
					data: this.inputs
				}).then(function(tag) {

					if (tag.migrate) {
						this.applyMigration(tag.id, tag.migrate)
						delete tag.migrate
					}

					this.$store.commit('data/tags/update', [tag])

					this.onClose()

				}.bind(this), function() {

					this.is.error = true
					this.is.loading = false

				}.bind(this))

			}

		},

		applyMigration: function(tagId, migrate) {

			var pages = ['collection', 'plays', 'ratings']
			var GAME = this.$CONSTANTS.TAG.CONTEXT.GAME

			pages.forEach(function(page) {

				this.$store.commit('page/' + page + '/tags/remove', {
					context: GAME,
					index: migrate.affectedGames,
					tag: tagId
				}, { root: true })

				this.$store.commit('page/' + page + '/tags/add', {
					context: migrate.context,
					index: migrate.index,
					tag: tagId
				}, { root: true })

			}.bind(this))

		},

		onMoveClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'tagMove',
				tag: this.data.tag
			})

		},

		onDeleteClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'tagDelete',
				tag: this.data.tag
			})

		},

		onClose: function() {

			this.$emit('close')
			
			if (this.isFamily) {

				this.$pubsub.$emit('open.modal', {
					id: 'tagFamilyManage',
					family: this.inputs.family
				})

			} else {
				
				this.$pubsub.$emit('open.modal', 'tagManage')

			}

		}

	}

}

</script>

<style scoped>

</style>